function LoadingPage({id}) {
  
  return (
    <div id={id} className = "loadingOverlayContainer">
      <div class="spinner-loader spinner-border" role="status"></div>  
    </div>
  )
}

export default LoadingPage
